import { Box, Table, Thead, Tbody, Tr, Th, Td, TableContainer, Text, Flex, IconButton, Button, Badge } from "@chakra-ui/react";
import { FaEdit, FaEye, FaEyeSlash, FaLanguage, FaPlus } from "react-icons/fa";
import { memo, useState } from "react";
import TranslationModal from "./TranslationModal";
import { stickyColHeaderProps, stickyColCellProps, stickyColShadow } from "../../constants/tableStyles";

const MenuItems = ({ items, onEdit, onDeactivate, sectionId }) => {
    const [translationItem, setTranslationItem] = useState(null);

    return (
        <>
            {items.length > 0 ? (
                <TableContainer borderRadius="md" overflowX="auto" boxShadow="md" mt={2}>
                    <Table variant="simple" size="md">
                        <Thead bg="surface.100">
                            <Tr>
                                <Th {...stickyColHeaderProps} bg="surface.100" boxShadow={stickyColShadow("#F4F7FB")}>#</Th>
                                <Th>Name</Th>
                                <Th>Description</Th>
                                <Th isNumeric>Price</Th>
                                <Th>Status</Th>
                                <Th>Actions</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {items.map((item, index) => (
                                <Tr key={item.id} _hover={{ bg: "brand.50" }}>
                                    <Td {...stickyColCellProps(false)}>{index + 1}</Td>
                                    <Td>{item.name}</Td>
                                    <Td>{item.description}</Td>
                                    <Td isNumeric>{item.price.toFixed(2)} {item.currency}</Td>
                                    <Td>
                                        <Badge colorScheme={item.isActive ? "green" : "red"}>
                                            {item.isActive ? "Aktivno" : "Neaktivno"}
                                        </Badge>
                                    </Td>

                                    <Td>
                                        <IconButton
                                            icon={<FaEdit />}
                                            size="sm"
                                            mr={2}
                                            onClick={() => onEdit("item", item)}
                                        />
                                        <IconButton
                                            icon={item.isActive ? <FaEyeSlash /> : <FaEye />}
                                            size="sm"
                                            mr={2}
                                            aria-label={item.isActive ? "Deactivate item" : "Activate item"}
                                            onClick={() => onDeactivate("item", item)}
                                        />
                                        <IconButton
                                            icon={<FaLanguage />}
                                            size="sm"
                                            aria-label="Translate item"
                                            onClick={() => setTranslationItem(item)}
                                        />
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </TableContainer>
            ) : (
                <Text>No items available.</Text>
            )}

            <Flex justify="center" mt={4}>
                <Button
                    leftIcon={<FaPlus />}
                    bg="white"
                    color="brand.700"
                    border="1px solid #154360"
                    borderRadius="full"
                    size="sm"
                    _hover={{ bg: "gray.100" }}
                    onClick={() => onEdit("item", { name: "", description: "", price: 0, currency: "EUR", sectionId })}
                >
                    Add Item
                </Button>
            </Flex>

            {translationItem && (
                <TranslationModal
                    entityType="item"
                    entity={translationItem}
                    onClose={() => setTranslationItem(null)}
                />
            )}
        </>
    );
};

export default memo(MenuItems);
